module.exports = __webpack_public_path__ + "static/media/integration.2c02b6f4.svg";